import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/nodes/ReferenceNodeContent/ReferenceNodeContent.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.function.name.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { useHover, useWithDelay } from '@gmini/utils';
import { NodeMoreActionButton } from '@gmini/ui-kit';
import { useDragLayer, useDrop } from 'react-dnd';
import { mergeReactRefs } from '@gmini/utils/lib/mergeReactRefs';
import { NodeDndManualSortButton } from "../../NodeDndManualSortButton";
import { buildKeyByPath } from "../../utils";
import { NumCycleContainer } from "../../../../components";
import { isHighlightedInSearch } from "../../../Common/isHighlightedInSearch";
import { NodeCheckbox } from "../../NodeCheckbox";
import { NodeExpand } from "../../../NodeExpand";
import { NodeLayout } from "../../NodeLayout";
import { BimNodeIcon } from "../../BimNodeIcon";
import { DndType } from "../../../DragNDrop/dndType";
import { useDragWithBeginDelay } from "../../../DragNDrop/useDragWithBeginDelay";
import { useNodeCtxMenu } from "../../TreeContextMenu/ctx";
import { useReadonlyMode } from "../../../../hooks";
import { getStyle } from "../../../Common/getStyle";
import { DndOverNodeContent } from "../../../Common/UI/DndOverNodeContent";
import { OverNodeBorder } from "../../../Common/UI/DndOverNodeContent.styled";
import { useOrderingNodeDnd } from "../dndOrdering";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ReferenceNodeContent = function ReferenceNodeContent(_ref) {
  var _node$source;

  var node = _ref.node,
      onClickNode = _ref.onClickNode,
      onDoubleClickNode = _ref.onDoubleClickNode,
      onExpandClick = _ref.onExpandClick,
      path = _ref.path,
      isExpanded = _ref.isExpanded,
      isSelected = _ref.isSelected,
      onCheckedNode = _ref.onCheckedNode,
      checkbox = _ref.checkbox,
      inSearch = _ref.inSearch,
      onPending = _ref.onPending,
      RenderNodeLayout = _ref.renderNodeLayout,
      highlighted = _ref.highlighted,
      treeItem = _ref.treeItem,
      dependencyData = _ref.dependencyData,
      onSearchSource = _ref.onSearchSource,
      onDroppedBefore = _ref.onDroppedBefore,
      onDroppedAfter = _ref.onDroppedAfter,
      canDropAfter = _ref.canDropAfter,
      canDropBefore = _ref.canDropBefore;

  var _useNodeCtxMenu = useNodeCtxMenu({
    path: path
  }),
      onContextMenu = _useNodeCtxMenu.onContextMenu,
      open = _useNodeCtxMenu.open,
      onClickOpen = _useNodeCtxMenu.onClickOpen;

  var matched = inSearch.matched,
      fullMatch = inSearch.fullMatch;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      canDrop = _useState2[0],
      setCanDrop = _useState2[1];

  var _useReadonlyMode = useReadonlyMode(),
      readonlyMode = _useReadonlyMode.readonlyMode;

  var _useDragWithBeginDela = useDragWithBeginDelay({
    item: {
      type: DndType.FROM_OWN_CLASSIFIER
    },
    begin: function begin() {
      onCheckedNode(true);
    },
    collect: function collect(m) {
      return {
        isDragging: m.isDragging(),
        canDrag: m.canDrag()
      };
    },
    canDrag: !readonlyMode.enabled && ((_node$source = node.source) === null || _node$source === void 0 ? void 0 : _node$source.relationType) !== 'Indirect'
  }),
      _useDragWithBeginDela2 = _slicedToArray(_useDragWithBeginDela, 3),
      isDragging = _useDragWithBeginDela2[0].isDragging,
      dragRef = _useDragWithBeginDela2[1],
      preview = _useDragWithBeginDela2[2];

  var _useDrop = useDrop({
    accept: [DndType.FROM_OWN_CLASSIFIER, DndType.FROM_DEPENDENCIES],
    canDrop: function canDrop() {
      return false;
    },
    collect: function collect(m) {
      return {
        isOver: m.isOver()
      };
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      isOver = _useDrop2[0].isOver,
      dropRef = _useDrop2[1];

  var _useWithDelay = useWithDelay({
    hover: isOver
  }, {
    enterDelay: 500,
    leaveDelay: 500
  }),
      isOverWithDelay = _useWithDelay.hover;

  var _useDragLayer = useDragLayer(function (monitor) {
    return {
      someoneDragging: monitor.isDragging()
    };
  }),
      someoneDragging = _useDragLayer.someoneDragging;

  React.useEffect(function () {
    if (someoneDragging) {
      setCanDrop(false);
      return function () {
        return setCanDrop(true);
      };
    }
  }, [someoneDragging]);

  var _useHover = useHover(),
      onMouseLeave = _useHover.onMouseLeave,
      onMouseOver = _useHover.onMouseOver,
      hover = _useHover.hover;

  React.useEffect(function () {
    preview(getEmptyImage(), {
      captureDraggingState: false
    });
  }, [preview]);
  var element = node.element;
  var expandable = 'total' in element && element.total > 0;

  var _isHighlightedInSearc = isHighlightedInSearch({
    matched: matched,
    fullMatch: fullMatch,
    isExpanded: expandable && isExpanded,
    highlighted: highlighted
  }),
      highlightedInSearch = _isHighlightedInSearc.highlightedInSearch;

  var style = getStyle({
    highlightedInSearch: highlightedInSearch,
    hover: open || hover,
    isSelected: isSelected,
    someoneDragging: someoneDragging,
    isDragging: isDragging,
    canDrop: canDrop
  });

  var _useOrderingNodeDnd = useOrderingNodeDnd({
    node: node,
    onDroppedAfter: onDroppedAfter,
    onDroppedBefore: onDroppedBefore,
    canDropAfter: canDropAfter,
    canDropBefore: canDropBefore,
    path: path
  }),
      dragOrderingRef = _useOrderingNodeDnd.dragOrderingRef,
      dropOrderingRef = _useOrderingNodeDnd.dropOrderingRef,
      canDropOrdering = _useOrderingNodeDnd.canDropOrdering,
      isBottomOver = _useOrderingNodeDnd.isBottomOver,
      isTopOver = _useOrderingNodeDnd.isTopOver;

  var deepness = path.length - 1;
  var nodeLayoutProps = {
    ref: mergeReactRefs(dropRef, dragRef, dropOrderingRef),
    icon: /*#__PURE__*/_jsx(BimNodeIcon, {
      type: node.element.type === 'BimModelNode' ? node.element.modelType : node.element.type
    }),
    text: element.name,
    onClick: onClickNode,
    onDoubleClick: onDoubleClickNode,
    onExpand: onExpandClick,
    onContextMenu: onContextMenu,
    onMouseOver: onMouseOver,
    onMouseLeave: onMouseLeave,
    style: _objectSpread({}, style),
    textStyle: {
      color: style.color
    },
    expandJsx: /*#__PURE__*/_jsx(NodeExpand, {
      onClick: onExpandClick,
      expanded: isExpanded,
      hidden: !expandable,
      hovered: hover
    }),
    checkbox: /*#__PURE__*/_jsx(NodeCheckbox, _objectSpread(_objectSpread({}, checkbox), {}, {
      onChange: function onChange(_, value) {
        return onCheckedNode(value);
      }
    })),
    deepness: deepness,
    numCycle: dependencyData && /*#__PURE__*/_jsx(NumCycleContainer, {
      dependencyData: dependencyData,
      onSearchSource: onSearchSource
    }),
    moreActionButton: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NodeDndManualSortButton, {
        ref: dragOrderingRef,
        show: hover
      }), /*#__PURE__*/_jsx(NodeMoreActionButton, {
        show: hover || open,
        active: open,
        onClick: onClickOpen
      })]
    }),
    hover: hover,
    pending: onPending(buildKeyByPath(path)),
    overLayoutContent: /*#__PURE__*/_jsx(DndOverNodeContent, {
      deepness: deepness,
      isMiddleOver: canDrop ? isOver : isOverWithDelay,
      isTopOver: isTopOver,
      isBottomOver: isBottomOver,
      isDragging: isDragging,
      canDrop: canDrop,
      someoneDragging: someoneDragging,
      overContent: /*#__PURE__*/_jsx(OverNodeBorder, {}),
      canDropOrdering: canDropOrdering
    })
  };

  if (RenderNodeLayout) {
    return RenderNodeLayout({
      node: node,
      nodeLayoutProps: nodeLayoutProps,
      path: path,
      treeItem: treeItem
    });
  }

  return /*#__PURE__*/_jsx(NodeLayout, _objectSpread({}, nodeLayoutProps));
};